import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";
import { CommonTLFModule } from '../../common/common.module';
import { FormCautelareComponent } from './form-cautelare/form-cautelare.component';
import { FormCautelareViewComponent } from "./form-cautelare/view/form-cautelare-view.component";
import { FormDibattimentoComponent } from './form-dibattimento/form-dibattimento.component';
import { FormDibattimentoViewComponent } from "./form-dibattimento/view/form-dibattimento-view.component";
import { FormIndaginiPreliminariComponent } from './form-indagini-preliminari/form-indagini-preliminari.component';
import {
  FormIndaginiPreliminariViewComponent
} from "./form-indagini-preliminari/view/form-indagini-preliminari-view.component";
import { FormRitiAlternativiComponent } from './form-riti-alternativi/form-riti-alternativi.component';
import { FormRitiAlternativiViewComponent } from "./form-riti-alternativi/view/form-riti-alternativi-view.component";
import { DynamicComponentService } from "./services/dynamic-component.service";
import { FormOrdinarioComponent } from './form-ordinario/form-ordinario.component';
import { FormOrdinarioViewComponent } from './form-ordinario/view/form-ordinario-view.component';
import { FormGenericoComponent } from './form-generico/form-generico.component';
import { FormGenericoViewComponent } from './form-generico/view/form-generico-view.component';
import { FormUdienzaPreliminareComponent } from './form-udienza-preliminare/form-udienza-preliminare.component';
import { FormUdienzaPreliminareViewComponent } from './form-udienza-preliminare/view/form-udienza-preliminare-view.component';
import { FormPredibattimentoComponent } from './form-predibattimento/form-predibattimento.component';
import { FormPredibattimentoViewComponent } from './form-predibattimento/view/form-predibattimento-view.component';

@NgModule({
    imports: [CommonTLFModule, CommonModule, RouterModule, NgbModule, FormsModule, ReactiveFormsModule, TagInputModule, NgSelectModule],
    declarations: [
        FormCautelareComponent,
        FormCautelareViewComponent,
        FormDibattimentoComponent,
        FormDibattimentoViewComponent,
        FormPredibattimentoComponent,
        FormPredibattimentoViewComponent,
        FormIndaginiPreliminariComponent,
        FormIndaginiPreliminariViewComponent,
        FormRitiAlternativiComponent,
        FormRitiAlternativiViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
        FormUdienzaPreliminareComponent,
        FormUdienzaPreliminareViewComponent
    ],
    providers: [DynamicComponentService],
    exports: [
        FormCautelareComponent,
        FormCautelareViewComponent,
        FormDibattimentoComponent,
        FormDibattimentoViewComponent,
        FormPredibattimentoComponent,
        FormPredibattimentoViewComponent,
        FormIndaginiPreliminariComponent,
        FormIndaginiPreliminariViewComponent,
        FormRitiAlternativiComponent,
        FormRitiAlternativiViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
        FormUdienzaPreliminareComponent,
        FormUdienzaPreliminareViewComponent
    ]
})
export class FascicoloFormSharedModule {

}
